import * as React from "react";
import MaskedInput from "react-number-format";
import TextField, { TextFieldProps } from "../TextField";

// import Styles from "./MaskedTextfield.css";

type Variant = "phone" | "ssn" | "money";

interface VariantProps {
  mask?: string;
  prefix?: string;
  thousandSeparator?: string;
}

type VariantList = Record<Variant, VariantProps>;

export interface Props {
  variant?: Variant;
}

const variantList: VariantList = {
  phone: { mask: "(###) ###-####" },
  ssn: { mask: "### ## ####" },
  money: { prefix: "$", thousandSeparator: "," }
};

const MaskedTextfield: React.FC<Props & TextFieldProps> = props => {
  const {
    id,
    className,
    defaultValue,
    errors,
    name,
    label,
    onChange,
    autoFocus,
    disabled,
    value,
    variant = "phone",
    required,
    helperText,
    inputRef,
    nativeRequired
  } = props;

  const currentVariant = variantList[variant];

  return (
    <MaskedInput
      className={className}
      format={currentVariant.mask}
      prefix={currentVariant.prefix}
      thousandSeparator={currentVariant.thousandSeparator}
      value={value}
      defaultValue={defaultValue}
      onChange={onChange}
      label={label}
      name={name}
      customInput={TextField}
      required={required}
      nativeRequired={nativeRequired}
      id={id}
      disabled={disabled}
      inputRef={inputRef}
      errors={errors}
      helperText={helperText}
      autoFocus={autoFocus}
    />
  );
};

export default MaskedTextfield;
